import { useEffect, useState } from "react";
import Search from "../assets/icons/search.svg";
import { SlArrowDown } from "react-icons/sl";
import DetailsCard from "../components/DetailsCard";
import Modal from "../components/modals/Modal";
import MaterialsModal from "../components/modals/MaterialsModal";
import { booksRecommendations } from "../data/MaterialsData";
import { ThreeDots } from "react-loader-spinner";
import Pagination from "../components/Pagination";
import DashboardLayout from "./DashboardLayout";

const Materials = () => {
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [books, setBooks] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  // PAGINATION STATES AND LOGIC
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;
  const chunkSize = 3;

  const totalPages = Math.ceil(books.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedItems = books.slice(startIndex, endIndex);

  const chunkStart = Math.floor((currentPage - 1) / chunkSize) * chunkSize;
  // const chunkEnd = chunkStart + chunkSize;

  //   FETCH BOOOK RECOMMENDATIONS
  useEffect(() => {
    const fetchData = async () => {
      try {
        // This is to demonstrate the loading state
        await new Promise((resolve) => setTimeout(resolve, 1000));
        setBooks(booksRecommendations);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [loading]);

  //   FETCH SEARCH RESULTS
  useEffect(() => {
    const filteredResults = booksRecommendations.filter((item) => {
      return item.name?.toLowerCase().includes(searchQuery.toLowerCase());
    });
    setSearchResults(filteredResults);
    // console.log('Filtered Results:', searchResults);
  }, [searchQuery]);

  return (
    <DashboardLayout materials="Materials" childTab={11} animated={true}>
      <div className="flex flex-col items-center justify-center w-full px-5 pb-7 mt-10 md:px-6 lg:relative lg:px-7 xl:px-10 xl:pb-10">
        {/*SEARCH*/}
        <div className="flex flex-col items-start mt-4 w-full bg-white md:mt-0">
          <p className="text-[11px] text-[#101828] font-medium xl:text-sm">
            Search Subjects
          </p>
          <div className="relative h-9  mt-1 w-full xl:h-11">
            <input
              className="border-[1px] rounded-md border-[#DDE1E6] h-full w-full bg-white text-[10px] text-[#101828] font-normal pl-9 outline-[#25A249] 
                                  xl:text-sm xl:pl-12 xl:rounded-lg"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search Subjects"
            />
            <img
              className="absolute left-3 top-[10px] w-[14px] xl:w-4 xl:top-[14px] xl:left-5"
              src={Search}
              alt="search_icon"
            />
          </div>
        </div>

        {/*TITLE*/}
        <div className="flex items-center justify-between w-full mt-6 xl:mt-7">
          <p className="text-[12px] font-semibold text-[#53545C] md:text-[13px] xl:text-base">
            Materials
          </p>

          <div className="flex items-center justify-end">
            <p className="text-[10px] font-semibold text-[#53545C] md:text-[11px] xl:text-[13px]">
              Show
            </p>
            <div className="flex items-center justify-between px-[6px] py-[3px] border-[1px] border-[#DDE1E6] rounded mx-[6px] md:mx-2 xl:mx-3">
              <p className="text-[10px] font-semibold text-[#53545C] md:text-[11px] xl:text-[13px]">
                12
              </p>
              <SlArrowDown className="text-[7px] ml-[10px] xl:ml-[14px] xl:text-[9px]" />
            </div>
            <p className="text-[10px] font-semibold text-[#53545C] md:text-[11px] xl:text-[13px]">
              entries
            </p>
          </div>
        </div>

        {/*SEARCH QUERY CARDS*/}
        {searchQuery !== "" && (
          <div className="flex items-center justify-between w-full flex-wrap mt-6 md:justify-start">
            {loading ? (
              <div className="flex items-start justify-center w-full h-screen mt-24">
                <ThreeDots color="#25A249" />
              </div>
            ) : searchResults.length > 0 ? (
              searchResults.map((item) => {
                return (
                  <DetailsCard
                    onClick={() => setModal(item)}
                    key={item.id}
                    data={item}
                    index={item.id}
                  />
                );
              })
            ) : (
              <div className="flex items-start justify-center w-full h-[50vh]">
                <p className="mt-24 font-semibold">Item not found...</p>
              </div>
            )}
          </div>
        )}

        {/*BOOKS PAGINATED CARDS*/}
        {searchQuery === "" && (
          <div className="flex items-start justify-between w-full flex-wrap mt-6 min-h-[50vh] md:justify-start md:min-h-[55vh] lg:min-h-[57vh]">
            {loading ? (
              <div className="flex items-start justify-center w-full h-screen mt-24">
                <ThreeDots color="#25A249" />
              </div>
            ) : (
              paginatedItems.map((item) => {
                return (
                  <DetailsCard
                    onClick={() => setModal(item)}
                    key={item.id}
                    data={item}
                    index={item.id}
                  />
                );
              })
            )}
          </div>
        )}

        {/*PAGINATION*/}
        {searchQuery === "" && (
          <div className="w-full">
            <Pagination
              setLoading={setLoading}
              totalPages={totalPages}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              chunkSize={chunkSize}
              chunkStart={chunkStart}
            />
          </div>
        )}

        {/*MODALS*/}
        {modal && (
          <Modal onClick={() => setModal(false)}>
            <MaterialsModal data={modal} setModal={setModal} />
          </Modal>
        )}
      </div>
    </DashboardLayout>
  );
};

export default Materials;
